import React, {useState} from 'react';
import { useMe } from "context/MeContext";
import { css } from '@emotion/react';
import { List } from "@pankod/refine-antd";
import "./cardAdmin.scss"
import RouterProvider from "@pankod/refine-react-router-v6";

interface CardProps {
  url: string;
  icon: string;
  title: string;
  description: string;
}
const { Link } = RouterProvider;
export const AdminCard: React.FC<CardProps> = ({url, icon, title, description}) => {
  return (
    <Link to={url} className="card">
        <div className="card-content">
          <div className="card-icon"><img src={icon} alt="" /></div>
          <div className="card-title">{title}</div>
          <div className="card-description">{description}</div>
        </div>
    </Link>
  );
};
